export const resolveMessage = (messages, path) => {
    try {
        const pathKeys = path.split(".");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const message = pathKeys.reduce((obj, key) => obj[key], messages);
        if (typeof message === "string") {
            return message;
        }
    }
    catch (e) { }
    // eslint-disable-next-line no-console
    console.warn(`Unable to resolve translation for path "${path}"`);
    return path;
};
export const injectVars = (message, vars = {}) => {
    return Object.keys(vars).reduce((str, varKey) => {
        return str.replace(new RegExp(`{${varKey}}`, "g"), `${vars[varKey]}`);
    }, message);
};
//# sourceMappingURL=helpers.js.map